<template>
  <div class="login">
    <BaseHeaderBar :title="title" :showCustomerService="false" :showBackButton="true" />
    <img class="login-icon" src="@/assets/img/login-icon.png" />
    <form class="login-content" @submit.prevent="onSubmit">
      <div class="input-block">
        <input v-model.trim="phone" type="tel" maxlength="13" autofocus
          placeholder="Masukkan nomor handphone dengan awalan 08" />
      </div>
      <div v-if="showPasswordInput" class="input-block">
        <input class="password" v-model.trim="password" maxlength="8" type="tel" :placeholder="tipText" />
      </div>
      <div class="input-block">
        <input v-model.trim="verifyCode" type="tel" maxlength="4"
          placeholder="Masukkan 4 digit angka kode verifikasi" />
        <div class="verify-code-btn" v-if="isGetCode" @click="getVerifyCode">
          Dapatkan kode verifikasi
        </div>
        <div class="verify-code-btn count-down" v-else>{{ countDown }}s</div>
      </div>
      <button type="submit" :class="['confirm-btn', showPasswordInput ? 'near' : 'far']">
        {{ buttonText }}
      </button>
    </form>

    <van-dialog v-model="showCodeChannelDialog" :showConfirmButton="false" :close-on-click-overlay="!isSendingCode"
      class="code-channel-dialog">
      <div class="code-channel-box">
        <i class="channel-close-btn" role="button" tabindex="0" aria-label="Tutup" @click="closeCodeChannelDialog"
          @keyup.enter="closeCodeChannelDialog"></i>
        <div :class="['channel-badge', codeChannel]">{{ isWaCodeChannel ? 'WA' : 'SMS' }}</div>
        <h3 class="channel-title">{{ channelText.title }}</h3>
        <p class="channel-desc">{{ channelText.description }}</p>
        <div v-if="isWaCodeChannel" class="channel-tips">
          <p v-for="(tip, index) in channelText.tips" :key="index">{{ tip }}</p>
        </div>
        <div class="channel-actions">
          <button type="button" class="channel-switch-btn" :disabled="isSendingCode" @click="switchCodeChannel">
            {{ switchCodeChannelText }}
          </button>
          <button type="button" class="channel-send-btn" :disabled="isSendingCode" @click="sendVerifyCode">
            Kirim
          </button>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="visible" :showConfirmButton="false" close-on-click-overlay class="verify-img-dialog">
      <h3 class="verify-title">Diperlukan verifikasi</h3>
      <div class="verify-body">
        <div class="verify-img-block">
          <div class="verify-img">
            <img ref="verifyImg" />
          </div>
          <div class="refresh-btn" @click="refreshVerifyCode">
            <img src="@/assets/img/refresh-icon.png" alt="refresh" />
          </div>
        </div>
        <div class="verify-input-box">
          <div v-for="(item, index) in verifyImgCodes" :key="index">
            <input :ref="`input${index}`" v-model="item.value" type="tel" @input="onInput(index)"
              @keyup.delete="onDelete(index)" maxlength="1" />
          </div>
          <p class="error-info">{{ errorInfo }}</p>
        </div>
        <button type="button" class="verify-confirm-btn" @click="onVerify">
          Yakin
        </button>
      </div>
      <img class="close-icon" src="@/assets/img/verify-close-icon.png" alt="close" @click="onCloseDialog()" />
    </van-dialog>
    <van-dialog v-model="showContactMsg" :showConfirmButton="false">
      <div class="showContactMsg">
        <h3>Tips Penting</h3>
        <p>Harap aktifkan izin buku alamat sesuai persyaratan berikut untuk terus menggunakannya:</p>
        <p>Harap aktifkan izin "Akses Penuh" untuk (nama aplikasi) di "Pengaturan" - "Privasi" - "Kontak" di iPhone
          Anda.</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Dialog } from 'vant'
import request from '@/utils/request'
import { validatePhoneNumber, validatePassword, validateVerifyCode } from '@/utils/validator'
import dialogVisible from '@/mixins/dialogVisible'
import { baseURL } from '@/config'
import { getContactsFromStorage } from '@/utils/submitContacts'

Vue.use(Toast)
const maxTime = 150
let timer
const clearTimer = () => {
  timer && clearTimeout(timer) && (timer = null)
}
const titleMap = {
  forgetPassword: 'Lupa Password',
  messageLogin: 'Login dengan SMS',
  register: 'Daftar'
}
const buttonText = {
  forgetPassword: 'Yakin',
  messageLogin: 'Login',
  register: 'Daftar'
}
const apiMap = {
  forgetPassword: 'usdrerForgetPassword',
  messageLogin: 'usdrerLogin',
  register: 'usdrerRegistration'
}

const messageTypeMap = {
  forgetPassword: 3,
  messageLogin: 2,
  register: 1
}

const codeTypeSms = 1
const codeTypeWhatsapp = 2
const codeChannelSms = 'sms'
const codeChannelWhatsapp = 'whatsapp'
const whatsappSentStorageKey = 'clh5WhatsappCodeSentMap'
const channelTextMap = {
  whatsapp: {
    title: 'Dapatkan kode verifikasi WhatsApp',
    description: 'Kode verifikasi telah dikirim ke WhatsApp Anda, harap periksa pesan WhatsApp Anda. Jika belum menerima, mohon perhatikan!',
    tips: [
      'Ponsel harus terpasang aplikasi WhatsApp',
      'WhatsApp harus dalam keadaan aktif / terbuka agar dapat menerima kode verifikasi',
      'Nomor ponsel yang didaftarkan harus memiliki akun WhatsApp'
    ]
  },
  sms: {
    title: 'Dapatkan kode verifikasi SMS',
    description: 'Kode verifikasi telah dikirim ke ponsel Anda, harap periksa SMS. Jika belum menerima, silakan cek folder spam / sampah SMS',
    tips: []
  }
}

export default {
  name: 'LoginForm',
  props: {
    type: {
      type: String,
      required: true
    }
  },
  mixins: [dialogVisible],
  data () {
    return {
      phone: '',
      password: '',
      verifyCode: '',
      isGetCode: true,
      countDown: maxTime,
      verifyImg: '',
      verifyImgCodes: [
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        }
      ],
      errorInfo: '',
      showContactMsg: false,
      showCodeChannelDialog: false,
      codeChannel: codeChannelSms,
      codeType: codeTypeSms,
      isSendingCode: false
    }
  },
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    title () {
      return titleMap[this.type]
    },
    buttonText () {
      return buttonText[this.type]
    },
    showPasswordInput () {
      return this.type === 'forgetPassword' || this.type === 'register'
    },
    tipText () {
      if (this.type === 'register') {
        return 'Atur 8 digit password'
      } else {
        return 'Masukkan 8 digit angka password'
      }
    },
    isWaCodeChannel () {
      return this.codeChannel === codeChannelWhatsapp
    },
    channelText () {
      return channelTextMap[this.codeChannel]
    },
    switchCodeChannelText () {
      return this.isWaCodeChannel ? 'SMS' : 'WhatsApp'
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.$nextTick(() => {
          this.getImgVerifyCode()
          this.$refs.input0[0].focus()
        })
      }
    }
  },
  created () {
    if (this.type === 'register') {
      const contant = getContactsFromStorage()
      if (contant.length === 0) {
        this.showContactMsg = true
      }
    }
  },
  methods: {
    validatePhoneNumber () {
      if (!this.phone) {
        Toast('Masukkan nomor handphone dengan awalan 08')
        return false
      }
      if (!validatePhoneNumber(this.phone)) {
        Toast('Nomor handphone salah')
        return false
      }
      return true
    },
    validate () {
      if (!this.validatePhoneNumber()) return false
      if (this.showPasswordInput) {
        if (!this.password) {
          Toast(this.tipText)
          return false
        }
        if (!validatePassword(this.password)) {
          Toast('Password salah')
          return false
        }
      }
      if (!this.verifyCode) {
        Toast('Masukkan 4 digit angka kode verifikasi')
        return false
      }
      if (!validateVerifyCode(this.verifyCode)) {
        Toast('Kode verifikasi salah')
        return false
      }
      return true
    },
    startCountDown () {
      if (this.countDown <= 0) {
        this.reset()
      } else {
        timer = setTimeout(() => {
          this.countDown--
          this.startCountDown()
        }, 1000)
      }
    },
    getVerifyCode () {
      if (!this.validatePhoneNumber()) return
      this.codeChannel = this.hasSentWhatsappToday() ? codeChannelSms : codeChannelWhatsapp
      this.showCodeChannelDialog = true
    },
    getTodayKey () {
      const now = new Date()
      const month = `${now.getMonth() + 1}`.padStart(2, '0')
      const date = `${now.getDate()}`.padStart(2, '0')
      return `${now.getFullYear()}-${month}-${date}`
    },
    getWhatsappSentMap () {
      try {
        return JSON.parse(localStorage.getItem(whatsappSentStorageKey)) || {}
      } catch (err) {
        return {}
      }
    },
    hasSentWhatsappToday () {
      const sentMap = this.getWhatsappSentMap()
      return sentMap[this.phone] === this.getTodayKey()
    },
    markWhatsappSentToday (phone = this.phone) {
      try {
        const sentMap = this.getWhatsappSentMap()
        sentMap[phone] = this.getTodayKey()
        localStorage.setItem(whatsappSentStorageKey, JSON.stringify(sentMap))
      } catch (err) {
        return false
      }
      return true
    },
    switchCodeChannel () {
      if (this.isSendingCode) return
      this.codeChannel = this.isWaCodeChannel ? codeChannelSms : codeChannelWhatsapp
    },
    closeCodeChannelDialog () {
      if (this.isSendingCode) return
      this.showCodeChannelDialog = false
    },
    getSendCodeApi (codeType) {
      return codeType === codeTypeWhatsapp ? 'sendWaSms' : 'usdrersendMessages'
    },
    sendVerifyCode () {
      if (!this.validatePhoneNumber()) return
      if (this.isSendingCode) return
      const codeType = this.isWaCodeChannel ? codeTypeWhatsapp : codeTypeSms
      const codeChannel = this.codeChannel
      const phone = this.phone
      const postData = {
        usdrerPhone: phone,
        tydrpe: messageTypeMap[this.type],
        smdrsType: 1
      }
      this.imgVerifyCode && (postData.imdrgCode = this.imgVerifyCode)
      this.isSendingCode = true
      request.post(this.getSendCodeApi(codeType), postData)
        .then(() => {
          this.codeType = codeType
          if (codeType === codeTypeWhatsapp) {
            this.markWhatsappSentToday(phone)
          }
          Toast(channelTextMap[codeChannel].description)
          this.showCodeChannelDialog = false
          this.countDown = maxTime
          this.isGetCode = false
          this.startCountDown()
        })
        .catch(err => {
          this.showCodeChannelDialog = false
          if (err.code === 504) {
            this.visible = true
          }
          this.reset()
        })
        .finally(() => {
          this.isSendingCode = false
        })
    },
    getImgVerifyCode () {
      this.$refs.verifyImg.src = `${baseURL}usdrergetGraphic?usdrerPhone=${this.phone}&t=${+Date.now()}`
    },
    reset () {
      clearTimer()
      this.isGetCode = true
      this.countDown = maxTime
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      const postData = {
        usdrerPhone: this.phone,
        smdrs_Verificationcode: this.verifyCode,
        smdrsType: 1,
        apdrpVersion: '1.0',
        codeType: this.codeType
      }
      if (this.type === 'forgetPassword') {
        postData.usdrerPassword = this.password
      } else if (this.type === 'messageLogin') {
        postData.lodrginType = 2
      } else if (this.type === 'register') {
        postData.enhedensdige = sessionStorage.getItem('enhedensdige')
        postData.dedrviceNo = sessionStorage.getItem('enhedensdige')
        postData.apitype = sessionStorage.getItem('apitype') || 1
        postData.usdrerPassword = this.password
        postData.prdromotionChannel = 'AppStore'
      }
      request.post(apiMap[this.type], postData)
        .then(res => {
          if (this.type === 'forgetPassword') {
            const { query } = this.$route
            this.$router.push({
              path: '/login',
              query
            })
          } else if (this.type === 'register' || this.type === 'messageLogin') {
            if (this.type === 'register' && window.webkit && window.webkit.messageHandlers) {
              // H5 中调用 Facebook 埋点
              if (window.webkit.messageHandlers.jkdkl) {
                window.webkit.messageHandlers.jkdkl.postMessage('')
              }
            }
            const form = {
              userIdBK: res.penggunaID,
              tokenBK: res.penggunaToken,
              versionBK: '1.0',
              deviceNoBK: sessionStorage.getItem('enhedensdige')
            }
            this.addressBook()
            this.$store.commit('recordInfo', {
              type: 'userBKInfo',
              value: form
            })
            localStorage.setItem('userBKInfo', JSON.stringify(form))
            this.$router.push('/home1')
          }
        }).catch(() => {
          this.verifyCode = ''
        }).finally(() => {
          this.flag = false
        })
    },
    onVerify () {
      this.imgVerifyCode = ''
      this.verifyImgCodes.forEach(item => {
        this.imgVerifyCode = this.imgVerifyCode + item.value
      })
      const postData = {
        usdrerPhone: this.phone,
        grdraphicCode: this.imgVerifyCode
      }
      request.post('usdrercheckGraphic', postData)
        .then(res => {
          Toast('Verifikasi Berhasil')
          this.visible = false
          this.sendVerifyCode()
        }).catch(() => {
          this.verifyImgCodes.forEach(item => {
            item.value = ''
          })
          this.getImgVerifyCode()
        })
    },
    refreshVerifyCode () {
      this.getImgVerifyCode()
    },
    onInput (index) {
      if (this.verifyImgCodes[index].value && index < 3) {
        console.log('onInput', index)
        this.$refs[`input${index + 1}`][0].focus()
      }
    },
    onDelete (index) {
      if (index > 0) {
        this.$refs[`input${index - 1}`][0].focus()
        console.log('onDelete', index)
      }
    }
  },
  deactivated () {
    this.reset()
  }
}
</script>

<style scoped lang="less">
.login {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}

.login-icon {
  width: 470px;
  height: 356px;
  padding-top: 30px;
  margin-left: auto;
  margin-right: auto;
}

.login-content {
  flex: 1;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 42px;
}

.input-block {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #b3b3b3;

  &:nth-child(n + 2) {
    margin-top: 26px;
  }

  input {
    flex: 1;
    width: 100%;
    height: 78px;
    line-height: 78px;
    padding: 0;
    border: none;
    font-size: 30px;
    color: #333;
    background-color: transparent;

    &::placeholder {
      color: #808080;
      font-size: 26px;
    }

    &:-webkit-autofill {
      transition: background-color 5000s ease-in-out 0s;
    }
  }
}

.verify-code-btn {
  width: 232px;
  height: 88px;
  border-width: 5px 4px;
  border-style: solid;
  border-color: #242d3c;
  box-sizing: border-box;
  margin-left: 10px;
  font-size: 26px;
  color: #4d4d4d;
  text-align: center;
}

.count-down {
  line-height: 88px;
}

.confirm-btn {
  .login-submit-btn;
  width: 100%;
  margin-top: 62px;
}

.code-channel-dialog {
  width: 620px;
  border-radius: 28px;
  overflow: visible;
}

.code-channel-box {
  position: relative;
  padding: 54px 42px 40px;
  border-radius: 28px;
  box-sizing: border-box;
  text-align: center;
  background-color: #fff;
}

.channel-close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 36px;
  height: 36px;
  cursor: pointer;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 17px;
    left: 4px;
    width: 28px;
    height: 2px;
    border-radius: 2px;
    background-color: #999;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
}

.channel-badge {
  width: 96px;
  height: 96px;
  line-height: 96px;
  border-radius: 50%;
  margin: 0 auto 24px;
  font-size: 32px;
  font-weight: 600;
  color: #fff;
  background-color: #242d3c;

  &.whatsapp {
    background-color: #29b66f;
  }
}

.channel-title {
  line-height: 42px;
  font-size: 30px;
  font-weight: 600;
  color: #1c2f51;
}

.channel-desc {
  line-height: 36px;
  margin-top: 22px;
  font-size: 24px;
  color: #4b5876;
}

.channel-tips {
  margin-top: 24px;
  padding: 22px 24px;
  border-radius: 16px;
  background-color: #f5f9ff;
  text-align: left;

  p {
    position: relative;
    line-height: 32px;
    padding-left: 22px;
    font-size: 22px;
    color: #4b5876;

    &::before {
      content: '';
      position: absolute;
      top: 13px;
      left: 0;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #242d3c;
    }

    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.channel-actions {
  display: flex;
  margin-top: 34px;
}

.channel-switch-btn,
.channel-send-btn {
  flex: 1;
  height: 80px;
  line-height: 80px;
  border: none;
  border-radius: 40px;
  font-size: 28px;
  font-weight: 600;
}

.channel-switch-btn {
  color: #242d3c;
  background-color: #eef4ff;
}

.channel-send-btn {
  margin-left: 24px;
  color: #fff;
  background-color: #242d3c;
}

.channel-switch-btn:disabled,
.channel-send-btn:disabled {
  opacity: 0.6;
}

.verify-title {
  line-height: 42px;
  padding-top: 48px;
  font-size: 30px;
  color: #000;
  text-align: center;
}

.verify-body {
  margin-left: 72px;
  margin-right: 72px;
}

.verify-img-block {
  display: flex;
  align-items: center;
  margin-top: 74px;
  height: 144px;
}

.verify-img {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border: 2px solid #b3b3b3;
  border-right: none;
  border-radius: 8px 0 0 8px;
  box-sizing: border-box;

  img {
    height: 100%;
  }
}

.refresh-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 78px;
  height: 100%;
  background-color: @theme-color;
  border-radius: 0px 8px 8px 0px;
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
  }
}

.verify-input-box {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;

  div {
    flex: 1;

    &:nth-child(n + 2) {
      margin-left: 64px;
    }
  }

  input {
    width: 100%;
    line-height: 88px;
    padding: 0;
    border: 2px solid #b3b3b3;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 30px;
    color: #333;
    text-align: center;
  }

  .error-info {
    margin-top: 8px;
    font-size: 24px;
    color: #e0383e;
  }
}

.verify-confirm-btn {
  .login-submit-btn;
  width: 546px;
  margin-top: 42px;
  margin-bottom: 38px;
}

.close-icon {
  position: absolute;
  top: 25px;
  right: 24px;
  width: 30px;
  height: 30px;
}

.password {
  -webkit-text-security: disc;
}

.showContactMsg {
  text-align: center;
  padding: 15px 10px;

  h3 {
    margin-bottom: 10px;
    margin-top: 25px;
  }

  p {
    line-height: 40px;
    padding: 10px
  }
}
</style>
